import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { slide as Menu } from 'react-burger-menu'

{/* LOGOS EN BLANCO */ }
import LogoMagueySVG from '../../../img/logoBlancoSVG2.svg';
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import estilos from './MenuHamburguesa.module.css'; { {/*Estilos para el componente*/ } }

import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faCheckDouble, faClock, faCalendar, faWrench,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faPenToSquare, faEdit, faPersonWalking, faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons'
import BotonMenuHamburguesa from './BotonMenuHamburguesa';

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faPenToSquare, faCheckDouble, faClock, faPersonWalking, faRightFromBracket,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faCalendar, faWrench)

const MenuHamburguesaDeveloper = (props) => {

    var styles = {
        bmBurgerButton: {
            position: 'fixed',
            width: '36px',
            height: '30px',
            left: '36px',
            top: '36px'
        },
        bmBurgerBars: {
            background: 'white'
        },
        bmBurgerBarsHover: {
            background: 'green'
        },
        bmCrossButton: {
            height: '24px',
            width: '24px'
        },
        bmCross: {
            background: 'white'
        },
        bmMenuWrap: {
            position: 'fixed',
            height: '100%'
        },
        bmMenu: {
            backgroundColor: 'purple',
            padding: '2.5em 1.5em 0',
            fontSize: '1.15em'
        },
        bmMorphShape: {
            fill: '#373a47'
        },
        bmItemList: {
            color: 'white',
            padding: '0.8em'
        },
        bmItem: {
            display: 'inline-block'
        },
        bmOverlay: {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    }
    const solicitudes = [
        {text: 'Estatus de solicitudes', ruta: '/SolicitudesDevComponent'},
        {text: 'Editar solicitudes', ruta: '/EditarSolicitudesDevComponent'},
    ];
    return (
        <Fragment>
            <div className={`${estilos.header}`}>
                <Fragment>
                    <header className='row text-center'>
                        <div className='col-10'>
                            <div className='row'>
                                <div className='col-4'></div>
                                <div className='col-7 mt-2' style={{ textAlign: 'center', fontSize: '10px !important' }}>
                                    <span className='textoEscondido text-center text-light'>
                                        <strong>PANEL DEVELOPER</strong><br />
                                    </span>
                                </div>

                            </div>
                        </div>
                        <div className='col-2 mt-3' style={{ textAlign: 'right', paddingRight: '4%', paddingTop: '1%' }}>
                            <Tooltip title="Salir de la aplicación" arrow>
                                <button style={{ border: 'none', padding: '4px', backgroundColor: 'transparent', color: 'white', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} onClick={props.cerrarSesionModal} className="text-wrap text-center botonZoom"> <FontAwesomeIcon style={{ transform: 'scale(1.5)' }} icon={faRightFromBracket} /><br />Salir</button>
                            </Tooltip>
                        </div>
                    </header>
                </Fragment>
            </div>

            <Menu styles={styles}>
                <List className={`${estilos.lista}`}>
                    <Fragment>
                        <BotonMenuHamburguesa titulo="SOLICITUDES" objeto={solicitudes} ruta="#" />
                        <BotonMenuHamburguesa titulo="CONSTANCIAS PDF MIGRACION" objeto={[]} ruta="/ConstanciasDevComponent" />
                    </Fragment>
                </List>
            </Menu>

            <br /><br /><br /><br />
            {props.componenteCerrarSesionModal}
        </Fragment >
    );
};

export default withRouter(MenuHamburguesaDeveloper)
